import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { requireBackoffice } from '../auth/guard.ts'
import { rootRoute } from './root.tsx'

// The sources of comunicati: one short list, so no search params.

export const bulletinSourcesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/bulletin-sources',
  beforeLoad: requireBackoffice,
  component: lazyRouteComponent(() => import('../pages/bulletin-sources.tsx')),
})
